import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import React, { useEffect } from 'react';
import Layout from './components/layout/Layout';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Services from './pages/Services/Services';
import Courses from './pages/Courses/Courses';
import Scholarships from './pages/Scholarships/Scholarships';
import Events from './pages/Events/Events';
import Spenden from './pages/Spenden/Spenden';
import NotFound from './pages/NotFound/NotFound';
import { useTranslation } from 'react-i18next';
import JobApplicationCourse from './pages/Courses/JobApplicationCourse';
import Satzung from './pages/Satzung';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Apply language-specific styles
    if (i18n.language === 'ar') {
      document.documentElement.dir = 'rtl';
      document.documentElement.lang = 'ar';
      document.documentElement.style.fontFamily =
        'Tajawal, sans-serif';
    } else {
      document.documentElement.dir = 'ltr';
      document.documentElement.lang = i18n.language;
      document.documentElement.style.fontFamily = 'Inter, sans-serif';
    }
  }, [i18n.language]);

  return (
    <I18nextProvider i18n={i18n}>
      <HelmetProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<Services />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/satzung" element={<Satzung />} />
              <Route path="/spenden" element={<Spenden />} />
              <Route
                path="/courses/job-application"
                element={<JobApplicationCourse />}
              />

              <Route
                path="/scholarships"
                element={<Scholarships />}
              />
              {/*<Route path="/events" element={<Events />} />*/}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </Router>
      </HelmetProvider>
    </I18nextProvider>
  );
}

export default App;
